<div class="text-area-container" [ngStyle]="{ 'max-height': height() }">
  @if (disabled()) {
    <span class="readonly text-content">{{ value() }}</span>
  } @else {
    <span class="text-area-label" [ngClass]="{ 'p-float-label': label() }">
      <textarea
        id="textarea"
        class="text-content"
        pTextarea
        [(ngModel)]="value"
        [ngStyle]="{ height: height() }"
        [attr.placeholder]="placeholder() || null"
        [required]="required()"
      ></textarea>
      @if (label()) {
        <label for="textarea">{{ label() }}</label>
      }
    </span>
  }
</div>
